export default function AnnouncementService() {
  const showNotification = ({
    message,
    title,
    Icon,
    Link,
    IsHighImportant,
  }) => {
    // create a new notification
    const notification = new Notification(title, {
      body: message,
      icon: Icon ? Icon : "/favicon.ico",
      // design announcement as a high priority
      priority: IsHighImportant ? "high" : "normal",
    });
    // navigate to a URL when clicked
    notification.addEventListener("click", () => {
      window.open(Link ? Link : "https://vn.nec.com/", "_blank");
    });
  };

  const showError = () => {
    alert("Vui lòng bật quyền thông báo trước khi gửi thông báo");
  };
  return { showNotification, showError };
}
